import { useQuery } from "react-query";
import {
    GetWarehouseResponse,
    ParamsGetWarehouseIsDueExpired,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetWarehouseIsDueExpired) => {
    const apiGetWarehouse = queryString.stringifyUrl({
        url: "api/warehouse",
        query: {
            search: `${params.search}`,
            size: params.size,
            page: params.page,
            isDueExpired: params.isDueExpired,
        },
    });
    const { data } = await axios.get<GetWarehouseResponse>(apiGetWarehouse);
    return data.data;
};

export default function useWarehouseIsDueExpired(
    params: ParamsGetWarehouseIsDueExpired,
) {
    return useQuery<GetWarehouseResponse["data"]>(
        ["warehouseIsDueExpired", params],
        () => handleRequest(params),
        { enabled: false },
    );
}
